function mobileNavInit() {
    const $icons = $('.header-wrapper .icon-menu');

    function openMenu() {
        const $menuContainer = $('.menu-primary-menu-container');
        const menuTopOffset = $('.header-main-background').height() + parseInt($('.header-global').css('top'));

        $menuContainer.addClass('active').css('padding-top', menuTopOffset);

        $('#icon-menu-open').removeClass('active').attr('aria-expanded', 'true');
        $('#icon-menu-close').addClass('active');
    }

    function closeMenu() {
        $('.menu-primary-menu-container').removeClass('active').css('padding-top', '');

        $('#icon-menu-open').addClass('active').attr('aria-expanded', 'false');
        $('#icon-menu-close').removeClass('active');
    }

    function mobileNavToggle() {
        if ($('.menu-primary-menu-container').height() == 0) {
            openMenu();
        } else {
            closeMenu();
        }
    }

    // Bind Events
    $icons.on('click', function (event) {
        mobileNavToggle();
    });

    // open menu by pressing return
    $icons.keydown(function (event) {
        if (event.keyCode == 13) {
            mobileNavToggle();
        }
    });

    // close mobile nav by pressing escape
    $(document).keyup(function (event) {
        if (27 == event.keyCode && $('.menu-primary-menu-container').height() > 0) {
            closeMenu();
        }
    });

    $(window).resize(function () {
        closeMenu();
    });
}

jQuery(document).ready(function () {
    'use strict';
    mobileNavInit();
});
